import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import InnerHeading from "../../Global Functions/innerHeading";
import { ReactComponent as DealsIcon } from "../../Global Icons/Deals.svg";
import { Link, useNavigate } from "react-router-dom";
import SelectInput from "../../Global Functions/selectInput";
import TextInput from "../../Global Functions/textInput";
import { useDispatch, useSelector } from "react-redux";
import {
  viewCategoryList,
  viewSubCategoryList,
} from "../../Redux/Actions/categoryActions";
import {
  viewCityListPagination,
  viewCountryListPagination,
  viewStateListPagination,
} from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";
import { addProject } from "../../Redux/Actions/projectActions";
import MapsAddress from "../../Global Functions/mapsAddress";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import AddImage from "../../Global Functions/addImage";
import MultipleImagesShowerModalGlobal from "../../Global Functions/multipleImagesShowerModalGlobal";
import AddProjectAmenities from "../../Global Functions/AddProjectAmenities";
import { viewAmenitiesList } from "../../Redux/Actions/amenitiesActions";
import AroundThisProject from "../../Global Functions/AroundThisProject";
import { getEnums } from "../../Redux/Actions/enumsActions";
import BrandsNearbyDropdown from "../../Commercial/Commercial Functions/Brands/brandsNearby";

const AddProject = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [aroundThisList, setAroundThisList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [projectPayload, setProjectPayload] = useState({
    added_by: "admin",
    project_name: "",
    brand_name: "",
    construction_status: "",
    builder_id: "",
    rera_id: "",
    builder_logo: "",
    project_type: "",
    categories: [],
    launch_date: "",
    street_address: "",
    lat: "",
    lng: "",
    quantity: "",
    brands_nearby: [
      {
        name: "",
        image_url: "",
      },
    ],
    city: "",
    starting_price: "",
    project_area: "",
    area_unit: "",
    state: "",
    country: "",
    possesion_date: "",
    booking_start_date: "",
    about_project: "",
    about_builder: "",
    around_this_project: [
      {
        icon: "",
        name: "",
        type: "",
        location: {
          type: "Point",
          coordinates: [null, null],
        },
        distance: null,
      },
    ],
    amenities: [],
    cover_photo: "",
    images: [],
  });

  const handlerNavigation = () => {
    navigate("/enquiry");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setProjectPayload((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleAddImages = async (event) => {
    const uploadedImage = event.target.files[0];
    if (!uploadedImage) {
      return toast.error("Please Upload Image");
    }
    const responseUrl = await AddImage(uploadedImage);
    if (responseUrl) {
      const newImage = {
        url: responseUrl,
        index: projectPayload.images.length + 1,
      };
      setProjectPayload((prevData) => ({
        ...prevData,
        images: [...prevData.images, newImage],
      }));
    }
  };

  const categoryAdditionHandler = (event) => {
    const selectedId = event.target.value;

    if (!selectedId) return;

    // Check if already added
    if (projectPayload.categories.includes(selectedId)) {
      toast.error("Category already exists!");
      return;
    }

    // Add only ID to payload
    const updatedCategories = [...projectPayload.categories, selectedId];

    setProjectPayload((prevData) => ({
      ...prevData,
      categories: updatedCategories,
    }));
  };

  const handleAddressChange = ({ address, lat, lng }) => {
    console.log("Address change received:", { address, lat, lng });
    setProjectPayload((prev) => ({
      ...prev,
      street_address: address,
      lat,
      lng,
    }));
  };

  const handleSubAmenitiesChange = (updated) => {
    setProjectPayload((prev) => ({
      ...prev,
      amenities: updated,
    }));
  };

  const handleSubmit = async () => {
    if (isSubmitting) return toast.error("Please Wait!!");
    try {
      setIsSubmitting(true);

      const patchedPayload = {
        ...projectPayload,
        area_unit:
          projectPayload.project_area > 0 && !projectPayload.area_unit
            ? "acre"
            : projectPayload.area_unit,
      };

      const isEmptyValue = (value) => {
        if (
          value === "" ||
          value === undefined ||
          value === null ||
          (typeof value === "number" && isNaN(value))
        ) {
          return true;
        }
        if (Array.isArray(value)) {
          return (
            value.length === 0 ||
            value.every(
              (item) =>
                typeof item === "object" &&
                item !== null &&
                Object.values(item).every(
                  (val) => val === "" || val === null || val === undefined
                )
            )
          );
        }

        return false;
      };

      const filteredPayload = Object.fromEntries(
        Object.entries(patchedPayload).filter(
          ([_, value]) => !isEmptyValue(value)
        )
      );

      const response = await dispatch(addProject(filteredPayload));
      response.statusCode === 200
        ? (window.location.href = "/enquiry")
        : toast.error(response?.message);
    } catch (error) {
      return;
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    setProjectPayload((prev) => ({
      ...prev,
      around_this_project: aroundThisList,
    }));
  }, [aroundThisList]);

  const handleCoverImage = async (event) => {
    const uploadedImage = event.target.files[0];
    if (!uploadedImage) {
      return toast.error("Please Upload Image");
    }
    const responseUrl = await AddImage(uploadedImage);

    if (responseUrl) {
      setProjectPayload((prevData) => ({
        ...prevData,
        cover_photo: responseUrl,
      }));
    }
  };

  useEffect(() => {
    dispatch(getEnums());
    const payload = {
      page: 1,
      limit: 2000,
    };
    dispatch(viewAmenitiesList(payload));
    dispatch(viewCategoryList(payload));
    dispatch(viewCountryListPagination());
    if (projectPayload.project_type) {
      const payload = {
        page: 1,
        limit: 2000,
        category_id: projectPayload.project_type,
      };
      dispatch(viewSubCategoryList(payload));
    }
    if (projectPayload.country) {
      dispatch(viewStateListPagination({ country: projectPayload.country }));
    }
    if (projectPayload.state) {
      dispatch(
        viewCityListPagination({
          state: projectPayload.state,
          country: projectPayload.country,
        })
      );
    }
  }, [
    dispatch,
    projectPayload.project_type,
    projectPayload.country,
    projectPayload.state,
  ]);

  const { categories, subCategories } = useSelector(
    (state) => state.categories || {}
  );
  const { countryList } = useSelector((state) => state.country || {});
  const { states } = useSelector((state) => state.states || {});
  const { cities } = useSelector((state) => state.city || {});
  const { amenities } = useSelector((state) => state.amenities || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});

  const projectAmenities = Array.isArray(amenities?.data)
    ? amenities.data.filter(
        (amenity) =>
          amenity?.project_type?._id === projectPayload.project_type &&
          amenity.amenities_for === "project"
      )
    : [];

  const handleBrandsAddition = (brands) => {
    setProjectPayload((prevData) => ({
      ...prevData,
      brands_nearby: brands,
    }));
  };

  const handleRemove = (idToRemove) => {
    const updated = projectPayload.categories.filter((id) => id !== idToRemove);
    setProjectPayload((prev) => ({ ...prev, categories: updated }));
  };

  return (
    <MainLayout>
      <div className="bg-white grid-span-5 radius-20 padding-20 grid-template-2 gap-10 width-100 height-100">
        <InnerHeading
          Icon={DealsIcon}
          onClick={() => handlerNavigation()}
          heading="Add Projects"
          buttonLabel=""
        ></InnerHeading>
        <TextInput
          required
          label="Brand Name"
          placeholder="Enter Name"
          name="brand_name"
          type="text"
          onChange={handleAddChange}
        ></TextInput>
        <div className="flex-container flex-column">
          <TextInput
            forImage={true}
            htmlFor="builder_logo"
            onChange={async (event) => {
              const uploadedFile = event.target.files[0];
              if (!uploadedFile) return;
              const fileType = uploadedFile.type;
              const fileName = uploadedFile.name.toLowerCase();

              if (fileType === "image/svg+xml" || fileName.endsWith(".svg")) {
                return toast.error("SVG files are not allowed.");
              }
              const responseUrl = await AddImage(uploadedFile);
              if (responseUrl) {
                setProjectPayload((prevData) => ({
                  ...prevData,
                  builder_logo: responseUrl,
                }));
              }
            }}
            type="file"
            span="Brand Logo"
            disabled={projectPayload.builder_logo ? true : false}
            label="Click to Upload Image"
            id="builder_logo"
            name="builder_logo"
          ></TextInput>
          <ImageShowerModalGlobal
            state={projectPayload}
            setState={setProjectPayload}
            keyField="builder_logo"
            file={projectPayload.builder_logo}
          ></ImageShowerModalGlobal>
        </div>
        <TextInput
          required
          name="project_name"
          placeholder="Enter Name"
          label="Project Name"
          type="text"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          required
          label="RERA-ID"
          placeholder="Enter RERA ID"
          name="rera_id"
          type="text"
          onChange={handleAddChange}
        ></TextInput>
        <SelectInput
          required
          placeholder="Select an Option"
          options={
            Array.isArray(categories?.data)
              ? categories.data.map((category) => ({
                  label: category.name,
                  value: category._id,
                }))
              : []
          }
          value={projectPayload.project_type}
          name="project_type"
          label="Project Type"
          onChange={handleAddChange}
        ></SelectInput>
        <div>
          <SelectInput
            placeholder="Select an Option"
            required
            value={
              projectPayload.categories[projectPayload.categories.length - 1]
            }
            disabled={projectPayload.project_type ? false : true}
            name="categories"
            options={
              Array.isArray(subCategories?.data)
                ? subCategories.data.map((category) => ({
                    label: category.name,
                    value: category._id,
                  }))
                : []
            }
            label="Category"
            onChange={categoryAdditionHandler}
          ></SelectInput>
          <div className="flex-container gap-10 margin-h-10">
            {projectPayload.categories.map((catId) => {
              const catObj = subCategories?.data.find(
                (cat) => cat._id === catId
              );
              return (
                <p key={catId} className="margin-0 border-1-grey padding-5">
                  {catObj?.name || "Unknown"}
                  <span
                    onClick={() => handleRemove(catId)}
                    style={{ color: "red", cursor: "pointer" }}
                  >
                    ❌
                  </span>
                </p>
              );
            })}
          </div>
        </div>
        <TextInput
          label="Project Area"
          required
          placeholder="Enter Area"
          name="project_area"
          type="number"
          onChange={handleAddChange}
        ></TextInput>
        <SelectInput
          label="Area in(Sq.ft/Acre)"
          value={projectPayload.area_unit}
          disabled={projectPayload.project_area ? false : true}
          placeholder="acre"
          name="area_unit"
          type="number"
          onChange={handleAddChange}
          options={
            enumsData?.data?.AreaUnit
              ? Object.values(enumsData.data.AreaUnit).map((item) => ({
                  label: item,
                  value: item,
                }))
              : []
          }
        ></SelectInput>
        <TextInput
          label="Launch Date"
          name="launch_date"
          max={projectPayload.possesion_date}
          type="date"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          label="Possession Date"
          disabled={projectPayload.launch_date ? false : true}
          name="possesion_date"
          type="date"
          min={projectPayload.launch_date}
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          label="Booking Start Date"
          name="booking_start_date"
          type="date"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          label="Starting Price"
          placeholder="Enter Price"
          type="number"
          min={0}
          onBlur={(event) => {
            const value = event.target.value;
            if (!value) {
              toast.error("Starting Price cannot be empty or invalid");
            }
          }}
          required
          onChange={handleAddChange}
          name="starting_price"
        ></TextInput>
        <SelectInput
          required
          name="country"
          value={projectPayload.country}
          placeholder="Select An Option"
          label="Country"
          options={
            Array.isArray(countryList?.data)
              ? countryList.data.map((category) => ({
                  label: category.country_name,
                  value: category._id,
                }))
              : []
          }
          onChange={handleAddChange}
        ></SelectInput>
        <SelectInput
          disabled={projectPayload.country ? false : true}
          required
          value={projectPayload.state}
          placeholder="Select An Option"
          options={
            Array.isArray(states?.data)
              ? states.data.map((category) => ({
                  label: category.state_name,
                  value: category._id,
                }))
              : []
          }
          name="state"
          label="State"
          onChange={handleAddChange}
        ></SelectInput>
        <SelectInput
          required
          value={projectPayload.city}
          placeholder="Select An Option"
          disabled={projectPayload.state ? false : true}
          options={
            Array.isArray(cities?.data)
              ? cities.data.map((category) => ({
                  label: category?.city_name,
                  value: category?._id,
                }))
              : []
          }
          name="city"
          label="City"
          onChange={handleAddChange}
        ></SelectInput>
        {categories?.data ? (
          categories?.data?.find((category) => category.name === "Commercial")
            ?._id === projectPayload.project_type ? (
            <div>
              <TextInput
                required
                label="Units in Project"
                onChange={handleAddChange}
                placeholder="Enter Units"
                type="number"
                min={0}
                name="quantity"
              ></TextInput>
              <div className="margin-h-10">
                <BrandsNearbyDropdown
                  onChange={handleBrandsAddition}
                ></BrandsNearbyDropdown>
              </div>
            </div>
          ) : null
        ) : (
          []
        )}
        <div
          disabled={projectPayload.city ? false : true}
          className="grid-span-2"
        >
          <MapsAddress
            disabled={projectPayload.city ? false : true}
            value={{
              address: projectPayload.street_address,
              lat: projectPayload.lat,
              lng: projectPayload.lng,
            }}
            onChange={handleAddressChange}
          ></MapsAddress>
        </div>
        <div className="grid-span-2">
          <AddProjectAmenities
            disabled={projectPayload.project_type ? false : true}
            onChange={handleSubAmenitiesChange}
            amenities={projectAmenities}
          ></AddProjectAmenities>
        </div>
        <div className="border-1-grey padding-10 border-24">
          <AroundThisProject
            aroundThisList={aroundThisList}
            setAroundThisList={setAroundThisList}
            onChange={(data) => console.log("Final list to send:", data)}
          ></AroundThisProject>
        </div>
        <SelectInput
          name="construction_status"
          onChange={handleAddChange}
          label="Select Construction Status"
          required
          value={projectPayload.construction_status}
          placeholder="Select an Option"
          options={
            enumsData?.data?.ConstructionStatus
              ? Object.values(enumsData.data.ConstructionStatus).map(
                  (item) => ({ label: item, value: item })
                )
              : []
          }
        ></SelectInput>
        <div className="grid-span-2">
          <TextInput
            name="about_project"
            label="About Project"
            type="text"
            placeholder="Enter Details"
            required
            onChange={handleAddChange}
          ></TextInput>
          <TextInput
            name="about_builder"
            label="About Builder"
            placeholder="Enter Details"
            type="text"
            onChange={handleAddChange}
          ></TextInput>
        </div>
        <div>
          <TextInput
            forImage={true}
            htmlFor="cover_photo"
            span="Cover Image(Maximum 1)"
            required
            onChange={(event) => handleCoverImage(event)}
            type="file"
            label="Click to Upload Image"
            id="cover_photo"
            name="cover_photo"
            disabled={projectPayload.cover_photo ? true : false}
          ></TextInput>
          <ImageShowerModalGlobal
            state={projectPayload}
            setState={setProjectPayload}
            keyField="cover_photo"
            file={projectPayload.cover_photo}
          ></ImageShowerModalGlobal>
        </div>
        <div>
          <TextInput
            forImage={true}
            htmlFor="images"
            onChange={(event) => handleAddImages(event)}
            type="file"
            multiple={true}
            span="Project Images"
            required
            label="Click to Upload Image"
            id="images"
            name="images"
          ></TextInput>
          <MultipleImagesShowerModalGlobal
            state={projectPayload.images}
            setState={setProjectPayload}
            fieldName="images"
          ></MultipleImagesShowerModalGlobal>
        </div>
        <div className="grid-span-2 flex-end">
          <Link to="/enquiry">
            <button className="button-class-white">Cancel</button>
          </Link>
          <button className="button-class" onClick={() => handleSubmit()}>
            Save
          </button>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddProject;
